import React from 'react';
import { AwardIcon, LeafIcon, MapPinIcon, CheckIcon } from 'lucide-react';
export function CreatorSection() {
  return <section className="bg-cream py-12 md:py-16 px-5" data-id="element-85">
      <div className="max-w-5xl mx-auto" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-87">
          {/* LEFT: Creator Photo */}
          <div className="order-2 lg:order-1 flex justify-center" data-id="element-88">
            <div className="relative w-full max-w-sm mx-auto" data-id="element-89">
              {/* Photo Container */}
              <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-xl relative" data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/tTTHNkRG51WtfdXtPhDyTy/fbb49c0d-ad88-4b14-883f-6a872d3e1c67.png" alt="Jonathan Mitchell — Certified Master Gardener" className="w-full h-full object-cover" data-id="element-91" />
                {/* Bottom Overlay */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-6 pt-16" data-id="element-92">
                  <p className="text-white font-bold font-sans text-xl mb-1" data-id="element-93">
                    Jonathan Mitchell
                  </p>
                  <p className="text-white/80 font-sans text-sm font-medium" data-id="element-94">
                    Master Gardener · USDA Certified
                  </p>
                </div>
              </div>
              {/* Decorative badge */}
              <div className="absolute -bottom-3 -right-3 bg-forest text-white rounded-xl px-4 py-2 shadow-lg flex items-center gap-2" data-id="element-95">
                <AwardIcon className="w-4 h-4 text-yellow-400" data-id="element-96" />
                <span className="font-sans text-xs font-bold" data-id="element-97">23+ Years</span>
              </div>
            </div>
          </div>

          {/* RIGHT: Bio & Credentials */}
          <div className="order-1 lg:order-2" data-id="element-98">
            <p className="font-sans text-sm font-semibold uppercase tracking-widest text-burnt mb-3" data-id="element-99">
              Meet The Creator
            </p>

            <h2 className="font-serif text-forest text-3xl md:text-4xl font-bold mb-2" data-id="element-100">
              Jonathan Mitchell
            </h2>

            <p className="text-forest-light font-sans text-lg mb-6 font-medium" data-id="element-101">
              Certified Master Gardener & Horticultural Consultant
            </p>

            <p className="text-gray-600 leading-relaxed mb-8 font-sans" data-id="element-102">
              "After 23 years of helping American homeowners protect and grow
              their gardens, I got tired of watching people lose hundreds of
              dollars in plants every season to problems that are completely
              preventable. The 365 Garden Shield is everything I teach my
              private clients — distilled into a simple, actionable system that
              anyone can follow. No jargon, no fluff — just the exact steps to
              keep your garden thriving 365 days a year."
            </p>

            {/* Credential Badges */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-103">
              <div className="flex items-center gap-3" data-id="element-104">
                <div className="w-10 h-10 rounded-lg bg-forest/10 flex items-center justify-center flex-shrink-0" data-id="element-105">
                  <AwardIcon className="w-5 h-5 text-forest" data-id="element-106" />
                </div>
                <div data-id="element-107">
                  <p className="font-semibold text-forest-dark text-sm font-sans" data-id="element-108">
                    23+ Years Experience
                  </p>
                  <p className="text-gray-500 text-xs font-sans" data-id="element-109">
                    Professional Horticulture
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3" data-id="element-110">
                <div className="w-10 h-10 rounded-lg bg-forest/10 flex items-center justify-center flex-shrink-0" data-id="element-111">
                  <LeafIcon className="w-5 h-5 text-forest" data-id="element-112" />
                </div>
                <div data-id="element-113">
                  <p className="font-semibold text-forest-dark text-sm font-sans" data-id="element-114">
                    10,000+ Gardens
                  </p>
                  <p className="text-gray-500 text-xs font-sans" data-id="element-115">
                    Helped Nationwide
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3" data-id="element-116">
                <div className="w-10 h-10 rounded-lg bg-forest/10 flex items-center justify-center flex-shrink-0" data-id="element-117">
                  <MapPinIcon className="w-5 h-5 text-forest" data-id="element-118" />
                </div>
                <div data-id="element-119">
                  <p className="font-semibold text-forest-dark text-sm font-sans" data-id="element-120">
                    All 50 States
                  </p>
                  <p className="text-gray-500 text-xs font-sans" data-id="element-121">
                    Climate Zone Expert
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3" data-id="element-122">
                <div className="w-10 h-10 rounded-lg bg-forest/10 flex items-center justify-center flex-shrink-0" data-id="element-123">
                  <CheckIcon className="w-5 h-5 text-forest" data-id="element-124" />
                </div>
                <div data-id="element-125">
                  <p className="font-semibold text-forest-dark text-sm font-sans" data-id="element-126">
                    USDA Certified
                  </p>
                  <p className="text-gray-500 text-xs font-sans" data-id="element-127">
                    Master Gardener Program
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}